import React, { useEffect, useState } from "react";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { FileCode2 } from "lucide-react";

export default function FacturXSettingsCard({ companyId }) {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    apiClient.get(`/my/companies/${companyId}`).then((r) => setEnabled(!!r.data?.facturx_enabled)).catch(() => {});
  }, [companyId]);

  const toggle = async (v) => {
    setBusy(true);
    try {
      await apiClient.patch(`/my/companies/${companyId}`, { facturx_enabled: v });
      setEnabled(v);
      toast.success(v ? "Factur-X aktiv: EU-Kunden erhalten Rechnungen mit eingebettetem XML" : "Factur-X deaktiviert");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Speichern fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="facturx-settings-card">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="text-sm font-medium text-slate-800 mb-1 flex items-center gap-1.5"><FileCode2 className="h-4 w-4" />E-Rechnung Factur-X / ZUGFeRD (EU)</h2>
          <p className="text-xs text-slate-500">
            Rechnungs-PDFs an Kunden mit Sitz in der EU erhalten beim E-Mail-Versand automatisch ein eingebettetes
            <span className="font-medium"> EN-16931-XML</span> (Factur-X / ZUGFeRD 2.x, PDF/A-3) – Pflichtformat für die E-Rechnung in Deutschland.
            Schweizer Kunden erhalten weiterhin das normale PDF mit Swiss QR. Manuell ist der Download in der Rechnungsliste jederzeit möglich.
          </p>
          <p className="text-[11px] text-slate-400 mt-1">Voraussetzung: Land beim Kunden erfasst (z. B. «DE»), Firmen-UID/MWST-Nr. und IBAN in den Firmendaten.</p>
        </div>
        <label className="inline-flex items-center gap-2 text-xs cursor-pointer shrink-0" data-testid="facturx-enabled-label">
          <Switch checked={enabled} onCheckedChange={toggle} disabled={busy || !companyId} data-testid="facturx-enabled-switch" />
          <span className="text-slate-700">{enabled ? "Aktiv" : "Aus"}</span>
        </label>
      </div>
    </div>
  );
}
